import SidePage from '@/shared/SidePage'
import { useState } from 'react'
import { IAlarmSituation } from '../../alarmSituations.types.ts'
import EditAlarmSituationsSidePageContent from './EditAlarmSituationsSidePageContent'
import ViewAlarmSituationSidePageContent from './ViewAlarmSituationSidePageContent'

interface IProps {
  open: boolean
  onClose: () => void
  onCloseAnimationEnd?: () => void
  alarmSituation: IAlarmSituation
}

const AlarmSituationsSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')

  const renderContent = () => {
    if (pageMode === 'edit') {
      return (
        <EditAlarmSituationsSidePageContent
          alarmSituation={props.alarmSituation}
          onCancel={() => setPageMode('view')}
        />
      )
    }

    return (
      <ViewAlarmSituationSidePageContent
        alarmSituation={props.alarmSituation}
        onEdit={() => setPageMode('edit')}
        onClose={props.onClose}
      />
    )
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} onCloseAnimationEnd={props.onCloseAnimationEnd}>
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.alarmSituation) return null

  return <AlarmSituationsSidePage {...props} />
}
